import { OPERATOR_EMAILS } from '@forwardflow/constants/onboarding.constants'

export const isOperatorEmail = (email: string) => {
   return OPERATOR_EMAILS.has(email)
}

export function buildOrgSwitchRedirectUrl(newOrgId: string): string {
   const url = new URL(window.location.href)
   if (url.searchParams.has('organizationId')) {
      url.searchParams.set('organizationId', newOrgId)
   }
   return url.pathname + url.search
}
